var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerts"},_vm._l((_vm.alerts),function(card,index){return _c('div',{key:index},[_c('v-alert',{staticClass:"font-bold",attrs:{"dense":"","prominent":"","elevation":"9","type":card.color === 'red' ? 'error' : 'success',"color":card.color ? card.color : 'green'}},[_vm._v("  "),_c('em',[_vm._v(_vm._s(card.msg))])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }